import { Helmet } from "react-helmet";
import { Img, Heading } from "../../components";
import NotificationsTable from "components/NotificationsTable";

import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_DOMAIN } from "config";
import NotificationCard from "components/NotificationCard";
import FilterBarNotifications from "components/FilterBarNotifications";
import { useNavigate } from "react-router-dom";
export default function NotificationsDealer({ currentUser, setCurrentUser }) {
  const [notifications, setNotifications] = useState([]);
  const [filters, setFilters] = useState({});
/** helpers */
const pad2 = (n) => String(n).padStart(2, "0");
const formatDayLabel = (dateLike) => {
  if (!dateLike) return "-";
  const d = new Date(dateLike);
  if (isNaN(d)) return "-";
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
};
const navigate = useNavigate();
const groupByDay = (list) => {
  const map = new Map();

  list.forEach((n) => {
    const dt = n?.created_at ?? n?.creation_date ?? n?.date ?? n?.createdAt;
    const dayLabel = formatDayLabel(dt);
    if (!map.has(dayLabel)) map.set(dayLabel, []);
    map.get(dayLabel).push(n);
  });

  // סדר ימים מהחדש לישן לפי תאריך אמיתי
  const entries = Array.from(map.entries()).map(([dayLabel, items]) => {
    const sample = items?.[0]?.created_at ?? items?.[0]?.creation_date ?? items?.[0]?.date ?? items?.[0]?.createdAt;
    const t = sample ? new Date(sample).getTime() : 0;

    // בתוך אותו יום – מהחדש לישן
    items.sort((a, b) => new Date(b.created_at ?? b.creation_date ?? b.date ?? b.createdAt) - new Date(a.created_at ?? a.creation_date ?? a.date ?? a.createdAt));
    return { dayLabel, t, items };
  });

  entries.sort((a, b) => b.t - a.t);
  return entries.map(({ dayLabel, items }) => ({ dayLabel, items }));
};
const fetchNotifications = async () => {
  if (!currentUser?.id) return;

  try {
    const { data } = await axios.get(
      `${API_DOMAIN}/notification/getUserNotifications`,
      {
        params: { user_id: currentUser.id },
      }
    );


    if (data?.success && Array.isArray(data.data)) {
      setNotifications(data.data);
    } else if (Array.isArray(data)) {
      setNotifications(data);
    } else {
      setNotifications([]);
    }
  } catch (err) {
    console.error("⛔ get notifications:", err);
    setNotifications([]);
  }
};

const getNotifId = (nOrId) => {
  if (typeof nOrId === "object" && nOrId) {
    return nOrId.notification_id ?? nOrId.notif_id ?? nOrId.id;
  }
  return nOrId;
};

const markRead = async (id) => {
  const notifId = getNotifId(id);
  if (!notifId) return;

  try {
    // ✅ בדיוק כמו NotificationsBell
    await axios.post(`${API_DOMAIN}/notification/markAsRead`, null, {
      params: { id: notifId, user_id: currentUser.id },
    });
  } catch (err) {
    console.error("⛔ mark-read:", err);
  }
};

const handleClose = async (nOrId) => {
  const notifId = getNotifId(nOrId);
  if (!notifId) return;

  // אופטימי ב-UI
  setNotifications((prev) =>
    prev.map((x) =>
      getNotifId(x) === notifId ? { ...x, is_read: 1 } : x
    )
  );

  // ✅ חשוב: לחכות שהשרת יעדכן
  await markRead(notifId);
};


  const unreadNotifications = useMemo(
    () =>
      [...notifications]
        .filter((n) => Number(n.is_read) === 0)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)),
    [notifications]
  );

  const readNotifications = useMemo(
    () =>
      [...notifications]
        .filter((n) => Number(n.is_read) === 1)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)),
    [notifications]
  );

const seenFilter = useMemo(() => {
  const seen = filters?.seen;

  // ✅ ברירת מחדל: רק "לא נקראו"
  if (!Array.isArray(seen) || seen.length === 0) {
    return { showRead: false, showUnread: true };
  }

  return {
    showRead: seen.includes("yes"),
    showUnread: seen.includes("no"),
  };
}, [filters]);
const visibleNotifications = useMemo(() => {
  const list = [];
  if (seenFilter.showUnread) list.push(...unreadNotifications);
  if (seenFilter.showRead) list.push(...readNotifications);

  // סדר מהחדש לישן
  return list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}, [seenFilter, unreadNotifications, readNotifications]);

const dayGroups = useMemo(() => groupByDay(visibleNotifications), [visibleNotifications]);

const noNotifications = visibleNotifications.length === 0;
  useEffect(() => {
    if (!currentUser?.id) return;
    fetchNotifications();
    const t = setInterval(fetchNotifications, 60_000);
    return () => clearInterval(t);
  }, [currentUser?.id]);


  return (
    <div className="dealer-profil notifications flex bg-blue_gray-50 sm:p-4">
      <div
        className="w-[100%] items-end gap-4 md:flex-col"
        style={{ gap: "2%" }}
      >
        <div style={{minHeight: '95.5vh'}} className="main-section flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
          <header className="flex flex-col items-start gap-3" dir="rtl" style={{ direction: "rtl" }}>
            <div className="flex items-center justify-between mt-2 self-stretch border-b border-solid border-gray-200 pb-3 md:flex-col md:items-start md:gap-3">
              
                  <div className="flex items-center gap-3 title-notif ml-auto">                <Img src="/images/bell.svg" alt="Bell" className="h-[32px]" />

                <Heading
                  size="heading9xl"
                  as="h4"
                  className="!font-heebo text-[25px] font-bold lg:text-[21px]"
                >
                  התראות
                </Heading>
              </div> 
            </div>

            {/* Filter bar centered under the title */}
            <div className="w-full flex justify-center">
              <div className="w-full flex justify-center">
                <div className="w-full max-w-[40rem]">
                  <FilterBarNotifications
                    unreadNotifications={unreadNotifications}
                    readNotifications={readNotifications}
                    onChange={(next) => setFilters(next ?? {})}
                  />
                </div>
              </div>
            </div>
          </header>

<div className="flex flex-col gap-8 text-right" style={{ minHeight: "60vh" }}>

  {/* === אין התראות כלל === */}
  {noNotifications && (
    <div className="flex flex-1 items-center justify-center" style={{ minHeight: "50vh" }}>
      <span className="text-gray-400 text-[16px] font-heebo">אין התראות להצגה</span>
    </div>
  )}

  {/* =========================
      ✅ DESKTOP: טבלה כמו CarsTable
      ========================= */}
  {!noNotifications && (
<div className="block md:hidden"> 
<NotificationsTable
  dayGroups={dayGroups}
  onMarkRead={handleClose}
onOpen={async (n) => {
  if (Number(n?.is_read) === 0) {
    await handleClose(n);
  }

  const carId = n?.car_id ?? n?.ad_id ?? n?.entity_id ?? n?.object_id; // ❌ בלי n.id
  if (carId) navigate(`/dealer-cars/${carId}`);
}}

 
/>
    </div>
  )}

  {/* =========================
      ✅ MOBILE: כרטיסיות כמו עכשיו
      אבל מחולק לפי ימים
      ========================= */}
  {!noNotifications && (
<div className="hidden md:flex flex-col gap-6">      {dayGroups.map((g) => (
        <div key={g.dayLabel} className="flex flex-col gap-3">
          {/* כותרת יום */}
          <div className="flex justify-end text-gray-500 text-[13px] font-heebo">
            {g.dayLabel}
          </div>

          <div className="flex flex-col gap-4">
            {g.items.map((n) => (
              <div
                key={n.id}
                className="relative py-4 border-b gray-200 opacity-90 text-right direction-rtl w-[100%]"
              >
                <NotificationCard
                  notification={n}
                  onClose={() => handleClose(n.id)}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )}

</div>

        </div>
      </div>
    </div>
  );
}
